module.exports = __webpack_public_path__ + "static/media/logo.c0039328.svg";